/**
 * @generated SignedSource<<bb6a36d193933c65f0cafb520b455f29>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OccurrencesOrderBy = "event_name" | "feedback" | "recording_watch_progress" | "start_date" | "%future added value";
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type OrganizationOccurrencesDatetimeFilter = "past" | "upcoming" | "%future added value";
export type AdminMembersReportEventsTablePaginationQuery$variables = {
  after?: string | null;
  appIds?: ReadonlyArray<string> | null;
  before?: string | null;
  datetimeFilter?: OrganizationOccurrencesDatetimeFilter | null;
  direction?: OrderDirection | null;
  excludeCommunityEvents?: boolean | null;
  first?: number | null;
  includedProductIds?: ReadonlyArray<string> | null;
  last?: number | null;
  memberHasAttended?: boolean | null;
  memberHasRSVP?: boolean | null;
  memberHasViewedRecording?: boolean | null;
  memberOrganizationMembershipId: string;
  orderBy?: OccurrencesOrderBy | null;
};
export type AdminMembersReportEventsTablePaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AdminMembersReportEventsTable_PaginationFragment">;
};
export type AdminMembersReportEventsTablePaginationQuery = {
  response: AdminMembersReportEventsTablePaginationQuery$data;
  variables: AdminMembersReportEventsTablePaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "before"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "datetimeFilter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "direction"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "excludeCommunityEvents"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includedProductIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "last"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "memberHasAttended"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "memberHasRSVP"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "memberHasViewedRecording"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "memberOrganizationMembershipId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orderBy"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "appIds",
    "variableName": "appIds"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "datetimeFilter",
    "variableName": "datetimeFilter"
  },
  {
    "kind": "Variable",
    "name": "direction",
    "variableName": "direction"
  },
  {
    "kind": "Variable",
    "name": "excludeCommunityEvents",
    "variableName": "excludeCommunityEvents"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "includedProductIds",
    "variableName": "includedProductIds"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  },
  {
    "kind": "Variable",
    "name": "memberHasAttended",
    "variableName": "memberHasAttended"
  },
  {
    "kind": "Variable",
    "name": "memberHasRSVP",
    "variableName": "memberHasRSVP"
  },
  {
    "kind": "Variable",
    "name": "memberHasViewedRecording",
    "variableName": "memberHasViewedRecording"
  },
  {
    "kind": "Variable",
    "name": "memberOrganizationMembershipId",
    "variableName": "memberOrganizationMembershipId"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  (v2/*: any*/)
],
v5 = [
  {
    "kind": "Variable",
    "name": "organizationMembershipId",
    "variableName": "memberOrganizationMembershipId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminMembersReportEventsTablePaginationQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "AdminMembersReportEventsTable_PaginationFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdminMembersReportEventsTablePaginationQuery",
    "selections": [
      {
        "alias": "occurrences",
        "args": (v1/*: any*/),
        "concreteType": "OccurrenceNodeConnection",
        "kind": "LinkedField",
        "name": "occurrencesReport",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OccurrenceNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Occurrence",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "datetimeRange",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Event",
                    "kind": "LinkedField",
                    "name": "event",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isRecurring",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Product",
                    "kind": "LinkedField",
                    "name": "product",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductApp",
                    "kind": "LinkedField",
                    "name": "app",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "customAppTitle",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OccurrenceMedia",
                    "kind": "LinkedField",
                    "name": "recording",
                    "plural": false,
                    "selections": (v4/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v5/*: any*/),
                    "concreteType": "OccurrenceRSVP",
                    "kind": "LinkedField",
                    "name": "organizationMembershipRSVP",
                    "plural": false,
                    "selections": (v4/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v5/*: any*/),
                    "concreteType": "OccurrenceAttendance",
                    "kind": "LinkedField",
                    "name": "organizationMembershipAttendance",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "attendedAt",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v5/*: any*/),
                    "concreteType": "EventFeedback",
                    "kind": "LinkedField",
                    "name": "organizationMembershipFeedback",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "instructorRating",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "videoQualityRating",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "contentRating",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "comments",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v5/*: any*/),
                    "concreteType": "AssetVideoProgress",
                    "kind": "LinkedField",
                    "name": "organizationMembershipRecordingVideoProgress",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "maxPercent",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfoObjectType",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "occurrences",
        "args": (v1/*: any*/),
        "filters": [
          "memberOrganizationMembershipId",
          "datetimeFilter",
          "includedProductIds",
          "excludeCommunityEvents",
          "memberHasRSVP",
          "memberHasAttended",
          "memberHasViewedRecording",
          "appIds",
          "orderBy",
          "direction"
        ],
        "handle": "connection",
        "key": "AdminMembersReportEventsTable_occurrences",
        "kind": "LinkedHandle",
        "name": "occurrencesReport"
      }
    ]
  },
  "params": {
    "cacheID": "7f8de476dbfe508c064530e21c008c76",
    "id": null,
    "metadata": {},
    "name": "AdminMembersReportEventsTablePaginationQuery",
    "operationKind": "query",
    "text": "query AdminMembersReportEventsTablePaginationQuery(\n  $after: String\n  $appIds: [ID!]\n  $before: String\n  $datetimeFilter: OrganizationOccurrencesDatetimeFilter\n  $direction: OrderDirection\n  $excludeCommunityEvents: Boolean\n  $first: Int\n  $includedProductIds: [ID!]\n  $last: Int\n  $memberHasAttended: Boolean\n  $memberHasRSVP: Boolean\n  $memberHasViewedRecording: Boolean\n  $memberOrganizationMembershipId: ID!\n  $orderBy: OccurrencesOrderBy\n) {\n  ...AdminMembersReportEventsTable_PaginationFragment_zz7mf\n}\n\nfragment AdminMembersReportEventsTableRowFragment_1Enw86 on Occurrence {\n  ...OccurrenceNameAndTimeFragment\n  name\n  datetimeRange\n  product {\n    name\n    id\n  }\n  app {\n    customAppTitle\n    id\n  }\n  recording {\n    id\n  }\n  organizationMembershipRSVP(organizationMembershipId: $memberOrganizationMembershipId) {\n    id\n  }\n  organizationMembershipAttendance(organizationMembershipId: $memberOrganizationMembershipId) {\n    attendedAt\n    id\n  }\n  organizationMembershipFeedback(organizationMembershipId: $memberOrganizationMembershipId) {\n    instructorRating\n    videoQualityRating\n    contentRating\n    comments\n    id\n  }\n  organizationMembershipRecordingVideoProgress(organizationMembershipId: $memberOrganizationMembershipId) {\n    maxPercent\n    id\n  }\n}\n\nfragment AdminMembersReportEventsTable_PaginationFragment_zz7mf on Query {\n  occurrences: occurrencesReport(first: $first, after: $after, last: $last, before: $before, memberOrganizationMembershipId: $memberOrganizationMembershipId, datetimeFilter: $datetimeFilter, includedProductIds: $includedProductIds, excludeCommunityEvents: $excludeCommunityEvents, memberHasRSVP: $memberHasRSVP, memberHasAttended: $memberHasAttended, memberHasViewedRecording: $memberHasViewedRecording, appIds: $appIds, orderBy: $orderBy, direction: $direction) {\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        ...AdminMembersReportEventsTableRowFragment_1Enw86\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      startCursor\n      hasNextPage\n      hasPreviousPage\n    }\n  }\n}\n\nfragment OccurrenceNameAndTimeFragment on Occurrence {\n  id\n  name\n  datetimeRange\n  event {\n    isRecurring\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f503ff9d7130b6bac1cd4595bcdbe5ab";

export default node;
